<template>
  <div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!activity"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-card shaped class="elevation-10" v-else>
      <v-card-title>
        <div>รายการกิจกรรม</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/activity/create">เพิ่มกิจกรรม</v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="searchChange"></v-text-field>
      </v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 15%;">รูปภาพกิจกรรม</th>
              <th style="width: 80%;">ชื่อกิจกรรม</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody v-if="activity.data.length > 0">
            <tr v-for="item in activity.data" :key="item.id">
              <td>
                <v-img 
                  v-if="item.cover_path"
                  class="my-4"
                  :src="`https://www.srru.ac.th/personnel/storage/activities/covers/${item.cover_path}`"
                  max-width="150"
                ></v-img>
                <v-subheader v-else>-</v-subheader>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <v-menu offset-y transition="fade-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item :to="`/activity/${item.id}/edit`">
                      <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                      <v-list-item-title>แก้ไข</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmDeleteForm(item.id)">
                      <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                      <v-list-item-title>ลบ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบกิจกรรมในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>
      <v-pagination
        class="pb-5"
        v-model="page"
        :length="activity.last_page"
        @input="selectPage"
      ></v-pagination>
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบกิจกรรม</v-card-title>
        <v-card-text>คุณต้องการลบกิจกรรมนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteForm()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    page: 1,
    term: '',
    type: '',
    activity: null,
    confirm_delete: false
  }),
  created() {
    this.getActivity('', this.page);
  },
  methods: {
    getActivity(term, page) {
      this.$store.dispatch('activity/list', {
        term: term,
        page: page
      }).then(data => this.activity = data);
    },
    deleteForm() {
      this.$store.dispatch('activity/delete', this.delete_selected).then(() => {
        this.getActivity('', 1);
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteForm(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    selectPage(e) {
      this.page = e;
      this.getActivity(this.term, e);
    },
    searchChange: _.debounce(function(e) {
      this.page = 1;
			this.getActivity(e, 1);
		}, 500),
  }
}
</script>